// 生成唯一的id
let idx = 0;
export function uniqueId() {
    return `v_${++idx}`;
}

// 用于参数校验的逻辑
export default class Validation {
    uuId = uniqueId();
    propName = "";
    isValid = true;
    message = "";
    parent = null;
    tiggerHanlder = null;
    childern = new Map();
    inValidSet = new Set();

    // 构造函数，初始化
    constructor({ tiggerHanlder, propName } = {}) {
        this.tiggerHanlder = tiggerHanlder;
        this.propName = propName;
    }

    // 上级调用，向下触发校验
    async validate() {
        if (this.tiggerHanlder) {
            // 有自己的校验函数，触发组件校验
            const result = await this.tiggerHanlder();
            this.isValid = result.isValid;
            this.message = result.message;
        } else if (this.childern.size !== 0) {
            // 中间节点触发子节点校验
            this.inValidSet.clear();
            for (const child of this.childern.values()) {
                const childResult = await child.validate();
                if (!childResult.isValid) {
                    this.inValidSet.add(child.uuId);
                }
            }
            this.evaluateValid();
        }
        return { isValid: this.isValid, message: this.message };
    }

    // 添加子节点
    addChild(child) {
        this.childern.set(child.uuId, child);
        child.parent = this;
    }

    // 删除子节点
    removeChild(uuId) {
        if (this.childern.has(uuId)) {
            this.childern.delete(uuId);
        }
        if (this.inValidSet.has(uuId)) {
            this.inValidSet.delete(uuId);
        }
    }

    // 触发上级校验，冒泡到最顶层
    emit({ isValid, message = "", uuId }) {
        if (!uuId || uuId === this.uuId) {
            // 当前节点状态触发
            this.message = message;
            this.isValid = isValid;
        } else {
            // 根据子节点状态设置本节点状态
            isValid && this.inValidSet.has(uuId) ? this.inValidSet.delete(uuId) : this.inValidSet.add(uuId);
            this.evaluateValid();
        }
        if (this.parent) {
            // 触发当前节点状态给父节点
            this.parent.emit(this);
        }
    }

    // 计算当前状态
    evaluateValid() {
        if (this.inValidSet.size === 0) {
            this.isValid = true;
            this.message = "";
        } else {
            this.isValid = false;
            const oneErrorChildUUID = this.inValidSet.values().next().value;
            this.message = this.childern.get(oneErrorChildUUID).message;
        }
    }

    // 销毁逻辑
    destroy() {
        if (this.parent) {
            this.parent.removeChild(this.uuId);
        }
    }
}
